<template>
    <div class="">
        <BannerPart/>
        <PhotoPart/>
        <WelcomePart/>
        <!-- <KeynotePart/> -->
        <OrganizePart/>
        <CoOrganizePart/>
    </div>
</template>

<script>
import BannerPart from './BannerPart/BannerPart.vue'
// import KeynotePart from './KeynotePart/KeynotePart.vue'
import OrganizePart from './OrganizePart/OrganizePart.vue'
import WelcomePart from './WelcomePart/WelcomePart.vue'
import CoOrganizePart from './CoOrganizePart/CoOrganizePart.vue'
import PhotoPart from './PhotoPart/PhotoPart.vue'  
    export default {
        components:{
            BannerPart,
            PhotoPart,
            WelcomePart,
            // KeynotePart,
            OrganizePart,
            CoOrganizePart
        }
    }
</script>

<style lang="less" scoped>
</style>